import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import {useUserData} from '@frontend/hooks'
import {
    useAuthStore,
    useTopMenuStore,
    useUiLayoutStore,
} from '@frontend/stores'
import {
    mdiCloseCircleOutline,
    mdiDotsVertical,
    mdiLogout,
} from '@mdi/js'
import {iconProfile} from '@shared/helpers/icons'
import clsx from 'clsx'
import {
    useEffect,
    useRef,
} from 'react'
import {useLocation} from 'react-router-dom'
import {FadeSwitch} from 'swayok-react-mdb-ui-kit/components/Animation/FadeSwitch'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {Dropdown} from 'swayok-react-mdb-ui-kit/components/Dropdown/Dropdown'
import {DropdownMenu} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownMenu'
import {DropdownToggle} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownToggle'
import type {DropdownApi} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownTypes'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {CabinetButtons} from './CabinetButtons'
import {CabinetLinks} from './CabinetLinks'
import {PublicLinks} from './PublicLinks'
import {TopNavigationCreateAdButton} from './TopNavigationCreateAdButton'
import {TopNavigationLogo} from './TopNavigationLogo'

// Верхнее меню навигации для мобильных телефонов.
export function TopNavigationMobile() {

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    const cabinetMode = useTopMenuStore(
        state => state.cabinetMode
    )
    const authBlock = useTopMenuStore(
        state => state.authBlock
    )
    const createAdButton = useTopMenuStore(
        state => state.createAdButton
    )

    const location = useLocation()

    const logout = useAuthStore(
        state => state.logout
    )
    const initUserAuthModal = useAuthStore(
        state => state.initUserAuthModal
    )
    const user = useUserData()

    // API выпадающего меню.
    const dropdownApiRef = useRef<DropdownApi>(null)

    // Закрывать меню при смене страницы.
    useEffect(() => {
        dropdownApiRef.current?.setIsOpen(false)
    }, [location.key])

    return (
        <div
            className={clsx(
                'inner-container flex-row-center-vertical position-relative',
                cabinetMode ? 'cabinet-mode' : 'public-mode'
            )}
        >
            <TopNavigationLogo
                isMobile
            />
            <div className="flex-1" />
            <CabinetButtons
                noLogout
                noLabels
                noSettings={bootstrapSize === 'xs'}
            />
            <Dropdown
                focusFirstItemOnOpen={false}
            >
                <DropdownToggle
                    color="link"
                    className="cabinet-link-icon"
                    hasIcon
                    renderContent={meta => (
                        <FadeSwitch transitionKey={meta.isOpen}>
                            <Icon
                                path={meta.isOpen ? mdiCloseCircleOutline : mdiDotsVertical}
                                size={26}
                            />
                        </FadeSwitch>
                    )}
                />
                <DropdownMenu
                    apiRef={dropdownApiRef}
                    drop="down"
                    align="end"
                    offset={10}
                    shadow="2-strong"
                    inline
                    noFocus
                    fillContainer
                    id="top-nav-dropdown-menu"
                >
                    <FadeSwitch transitionKey={cabinetMode}>
                        {cabinetMode ? (
                            <CabinetLinks />
                        ) : (
                            <PublicLinks />
                        )}
                    </FadeSwitch>
                    <Button
                        color="link"
                        className="with-icon-flex justify-content-between"
                        href={appUrl().cabinet.default}
                        onClick={e => {
                            if (initUserAuthModal()) {
                                e.preventDefault()
                                return
                            }
                        }}
                    >
                        <span>{trans().common.top_navigation.cabinet}</span>
                        <Icon
                            path={iconProfile}
                            className="ms-1"
                        />
                    </Button>
                    <Button
                        visible={!!user}
                        color="link"
                        className="with-icon-flex justify-content-between mb-1"
                        href={appUrl().logout}
                        onClick={e => {
                            e.preventDefault()
                            logout()
                        }}
                    >
                        <span>{trans().common.top_navigation.logout}</span>
                        <Icon
                            path={mdiLogout}
                            className="ms-1"
                        />
                    </Button>
                    {createAdButton && (authBlock || cabinetMode) && (
                        <TopNavigationCreateAdButton forMobile />
                    )}
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}
